module.exports={
	"Form": "CertificationTypeEditManifest",
	"Scope": "CertificationType-Edit",
	"Descriptors":
	{
		"CertificationTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "CertificationType-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "CertificationType-Edit-Identity",
				"Group": "CertificationType-Edit-Identity"
			}
		},
		"CertificationTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "CertificationType-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-Edit-Details",
				"Group": "CertificationType-Edit-Details"
			}
		},
		"CertificationTypeDetails.Verb":
		{
			"Name": "Verb",
			"Hash": "CertificationType-Edit-Verb",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-Edit-Details",
				"Group": "CertificationType-Edit-Details"
			}
		},
		"CertificationTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "CertificationType-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "CertificationType-Edit-Details",
				"Group": "CertificationType-Edit-Details"
			}
		},
		"CertificationTypeDetails.IDCertificationType":
		{
			"Name": "IDCertification Type",
			"Hash": "CertificationType-Edit-IDCertificationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.GUIDCertificationType":
		{
			"Name": "GUIDCertification Type",
			"Hash": "CertificationType-Edit-GUIDCertificationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "CertificationType-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "CertificationType-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "CertificationType-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "CertificationType-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CertificationType-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CertificationType-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "CertificationType-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "CertificationType-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "CertificationType-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "CertificationType-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
